// The generic one-line confirm for every spend that is not the Prepare sheet:
// adding a file, a re-prepare, touch-ups, video.
//
//   Add a Branded PDF
//   Uses 100 credits · you have 400
//   [Not now]  [Add]
//
// The balance shown is a preview; the confirm button stays enabled even when
// it reads as blocked, because the server's 409 is the authority (the caller
// routes that 409 to CreditsPaywallSheet).

import CostLine from "./CostLine";
import Sheet, {
  SheetActions,
  SheetError,
  SheetPrimary,
  SheetSecondary,
  SheetText,
  SheetTitle,
} from "./Sheet";

/**
 * @param {{
 *   title: string,
 *   cost: number,
 *   balance?: number | null,
 *   onConfirm: () => void,
 *   onClose: () => void,
 *   busy?: boolean,
 *   note?: string,
 *   error?: string | null,
 *   confirmLabel?: string,
 * }} props
 *   note: one quiet line under the fact ("Takes about a minute.").
 *   confirmLabel: defaults to "Add"; re-prepare passes "Re-prepare", etc.
 */
const ConfirmSpendSheet = ({
  title,
  cost,
  balance,
  onConfirm,
  onClose,
  busy = false,
  note,
  error,
  confirmLabel = "Add",
}) => (
  <Sheet labelledBy="confirm-spend-title" onClose={busy ? undefined : onClose}>
    <SheetTitle id="confirm-spend-title">{title}</SheetTitle>
    <CostLine cost={cost} balance={balance} />
    {note && <SheetText style={{ marginTop: 8 }}>{note}</SheetText>}
    {error && <SheetError role="alert">{error}</SheetError>}
    <SheetActions>
      <SheetSecondary type="button" onClick={onClose} disabled={busy}>
        Not now
      </SheetSecondary>
      <SheetPrimary type="button" onClick={onConfirm} disabled={busy}>
        {busy ? "Working…" : confirmLabel}
      </SheetPrimary>
    </SheetActions>
  </Sheet>
);

export default ConfirmSpendSheet;
